export const EBankAccountType = {
  Checking: "checking",
  Savings: "savings",
} as const;

export type EBankAccountType =
  (typeof EBankAccountType)[keyof typeof EBankAccountType];
